export default {
    init() {
        setupBlocks();
    }
}

function setupBlocks() {
    let $blocks = $('.page-block-text-row-carousel').not('.initialised');

    if ($blocks.length > 0) {
        $blocks.each((index, item) => {
            let $block = $(item);

            setupBlock($block);

            $block.addClass('initialised');
        });
    }
}

function setupBlock($block) {
    let $textRowCarousel = $block.find('.text-row-carousel');

    $textRowCarousel.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        draggable: true,
        mobileFirst: true,
        variableWidth: true,
        centerMode: true,
        infinite: true,

        responsive: [
            {
                breakpoint: 768,
                settings: 'unslick'
            }
        ]
    });
}